exports = module.exports = require("../../../_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".van-dropdown-item {\n  position: fixed;\n  right: 0;\n  left: 0;\n  z-index: 10;\n  overflow: hidden;\n}\n\n.van-dropdown-item__icon {\n  display: block;\n  line-height: inherit;\n}\n\n.van-dropdown-item__option {\n  text-align: left;\n}\n\n.van-dropdown-item__option--active {\n  color: #ee0a24;\n}\n\n.van-dropdown-item__option--active .van-dropdown-item__icon {\n  color: #ee0a24;\n}\n\n.van-dropdown-item--up {\n  top: 0;\n}\n\n.van-dropdown-item--down {\n  bottom: 0;\n}\n\n.van-dropdown-item__content {\n  position: absolute;\n  max-height: 80%;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.28.11@css-loader?{"minimize":false,"sourceMap":false}!./~/_px2rem-loader@0.1.9@px2rem-loader?{"remUnit":37.5}!./~/_vant@2.13.2@vant/lib/dropdown-item/index.css
// module id = 222
// module chunks = 320 321